export const escapeRegexCharacters = (str: string): string => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const formatSearchTitleResult = (searchTitle: string): string => searchTitle.replaceAll("<search-hl>", "").replaceAll("</search-hl>", "");

export const formatPrice = (price: string) => {
	return parseFloat(price)
		.toFixed(2)
		.replace(".", ",")
		.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const convertToSlug = (text: string): string => {
	return text
		.toLowerCase()
		.replace(/[^\w ]+/g, "")
		.replace(/ +/g, "-");
};

export const calculateDiscountPercentage = (regularPrice: string, actualPrice: string) => {
	const parsedRegularPrice = parseFloat(regularPrice.replace(',', '.'));
	const parsedActualPrice = parseFloat(actualPrice.replace(',', '.'));
	return Math.round(100 * (parsedRegularPrice - parsedActualPrice) / parsedRegularPrice);
}
